import { ShopOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import InputField from '../../InputField';
import { type SelectFieldProps } from '../../SelectField';
import { type TranslationDrawerProps } from '../../TranslatedInputField/TranslationDrawer';
import {
    type DealershipTranslatedStringDrawerProps,
    useDealershipTranslatedStringDrawer,
} from './DealershipTranslatedStringDrawer';

export type DealershipTranslatedStringInputFieldProps = Pick<
    SelectFieldProps,
    'options' | 'name' | 'disabled' | 'label' | 'itemProps'
> &
    Pick<DealershipTranslatedStringDrawerProps, 'dealers'> &
    Pick<TranslationDrawerProps, 'languages'> & { isEdit?: boolean; isMultipleEntry?: boolean };

const DealershipTranslatedStringField = ({
    name,
    dealers,
    disabled,
    languages,
    options,
    isEdit,
    isMultipleEntry,
    ...props
}: DealershipTranslatedStringInputFieldProps) => {
    const drawer = useDealershipTranslatedStringDrawer();

    // hide button completely when disable
    const button = disabled ? null : (
        <Button
            icon={<ShopOutlined style={{ color: 'var(--ant-primary-color)' }} />}
            onClick={drawer.open}
            size="small"
            type="text"
        />
    );

    return (
        <>
            <Col onClick={drawer.open}>
                <InputField
                    name={`${name}.defaultValue.defaultValue`}
                    {...props}
                    addonAfter={button}
                    onClick={drawer.open}
                    style={{ width: '100%' }}
                    disabled
                />
            </Col>
            {drawer.render({ name, title: props.label, dealers, options })}
        </>
    );
};

export default DealershipTranslatedStringField;
